import React from 'react';
import {message, Spin, Table} from 'antd';
import {gaEventWithUserIdLabel, LOG_OUT} from "../../constants";
import DashboardService from "../../services/dashboard.service";
import AuthService from "../../services/auth.service";
import GraphPair from "./GraphPair";
import i18n from "i18next";
import './index.css'
import ServicesMap from './ServicesMap';



function percentage(partialValue, totalValue) {
    const perc = ((100 * partialValue) / totalValue).toFixed()
    return isNaN(perc) ? 0 : perc;
}

function getPercentageChange(oldNumber, newNumber) {
    var decreaseValue = newNumber - oldNumber;
    const perc = ((decreaseValue / oldNumber) * 100).toFixed(2)
    return isNaN(perc) ? 0 : perc;
}

var onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
};

export default class DashboardContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            
            data_lists_table_columns:
                [
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key:"data_list_name"
                    },
                    {
                        title: 'Last Checked',
                        dataIndex: 'last_checked',
                        sorter: {
                            compare: (a, b) => a.last_checked - b.last_checked,
                            multiple: 5,
                        },
                        key:"last_checked"
                    },
                    {
                        title: 'Last Updated',
                        dataIndex: 'last_updated',
                        key:"last_updated",
                        sorter: {
                            compare: (a, b) => a.last_updated - b.last_updated,
                            multiple: 4,
                        },
                    },
                    {
                        title: 'Data Count Raise',
                        dataIndex: 'data_count_raise',
                        key:"data_count_raise",
                        sorter: {
                            compare: (a, b) => a.data_count_raise - b.data_count_raise,
                            multiple: 3,
                        },
                    },
                    {
                        title: 'Total Data',
                        dataIndex: 'total_data',
                        key:"total_data",
                        sorter: {
                            compare: (a, b) => a.total_data - b.total_data,
                            multiple: 2,
                        },
                    },
                    {
                        title: 'Total Matches',
                        dataIndex: 'total_matches',
                        key:"list_total_matches",
                        sorter: {
                            compare: (a, b) => a.total_matches - b.total_matches,
                            multiple: 1,
                        },
                    }

                ],
            clients_table_columns:
                [
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key:"client_name,"
                    },
                    {
                        title: 'Company Name',
                        dataIndex: 'company_name',
                        key:"company_name",
                    },
                    {
                        title: 'Searched',
                        dataIndex: 'searches_count',
                        key:"searches_count",
                        sorter: {
                            compare: (a, b) => a.searches_count - b.searches_count,
                            multiple: 3,
                        },
                    },
                    {
                        title: 'Matched',
                        dataIndex: 'matches_count',
                        key:"matches_count",
                        sorter: {
                            compare: (a, b) => a.matches_count - b.matches_count,
                            multiple: 2,
                        },
                    },
                    {
                        title: 'Credits Left',
                        dataIndex: 'credits_left',
                        key:"credits_left",
                        sorter: {
                            compare: (a, b) => a.credits_left - b.credits_left,
                            multiple: 1,
                        },
                    },
                    {
                        title: 'Licence Left',
                        dataIndex: 'licenseEndDate',
                        key:"licenseEndDate",
                    }
                ],
        }

        this.dashboardData();
        this.dashboardServiceData();
    }

    dashboardData() {
        DashboardService.getDashboardData()
            .then(
                response => {
                    if (response.data) {

                        const userActivities = response.data.userActivities
                        const dailyData = response.data.dailyData
                        const dataListsData = response.data.dataListsData

                        this.setState({dailyData, userActivities, dataListsData})

                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("DashboardService.findAllUserActivities Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }


    dashboardServiceData = () => {
        DashboardService.getDashboardServiceData()
            .then(
                response => {
                    if (response.data) {

                        const serviceData = response.data.serviceData                       
                        
                        let copyState = this.state

                        copyState.serviceData = serviceData

                        this.setState(copyState)
                        

                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("DashboardService.findAllUserActivities Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    

    render() {

        if(this.state.dataListsData){
            for(var i=0;i<this.state.dataListsData.length;i++){
                let list = this.state.dataListsData[i]
                list["name"] = i18n.t(list.name+"_short_name")
            }
        }

        
        
        const {clients_table_columns, userActivities} = this.state;

        if(this.state.dailyData){
            var daily_data = this.state.dailyData;
            var todays_data = daily_data[daily_data.length - 1]

            var searches_graph_data = daily_data.map(data => {
            return {name: data.day.toString(), uv: data["total_searches"]}
        });
            var matches_graph_data = daily_data.map(data => {
            return {name: data.day.toString(), uv: data["total_matches"]}
        });
            var matchrate_graph_data = daily_data.map(data => {
            return {name: data.day.toString(), uv: percentage(data["total_matches"], data["total_searches"])}
        });
        }

        

        if(this.state.dailyData){
        var searches_data_change = getPercentageChange(searches_graph_data[searches_graph_data.length - 2].uv, searches_graph_data[searches_graph_data.length - 1].uv)
        var matches_data_change = getPercentageChange(matches_graph_data[matches_graph_data.length - 2].uv, matches_graph_data[matches_graph_data.length - 1].uv)
        var matchrate_data_change = getPercentageChange(matchrate_graph_data[matchrate_graph_data.length - 2].uv, matchrate_graph_data[matchrate_graph_data.length - 1].uv)

        var searches_box_data = {
            name: "Total Searches",
            data: todays_data["total_searches"],
            change: searches_data_change
        };
        var matches_box_data = {
            name: "Total Matches",
            data: todays_data["total_matches"],
            change: matches_data_change
        };
        var matchrate_box_data = {
            name: "Match Rate",
            data: matchrate_graph_data[matchrate_graph_data.length - 1].uv,
            change: matchrate_data_change
        };
        }

        
        
        return (
            <div className='dashboard-container'>

                <h1>Clients</h1>
                <hr/>

                {this.state.userActivities ? <Table columns={clients_table_columns} dataSource={userActivities} onChange={onChange}/> : <Spin/>}

                <h1>Searches</h1>
                <hr />

                {
                    this.state.dailyData ? 
                        <>
                            <GraphPair box_data={searches_box_data} graph_data={searches_graph_data} />
                            <GraphPair box_data={matches_box_data} graph_data={matches_graph_data} />
                            <GraphPair box_data={matchrate_box_data} graph_data={matchrate_graph_data} />
                        </>
                        :
                        <>
                            <Spin/>
                            <Spin/>
                            <Spin/>
                        </>
                }
                
                <h1>Services</h1>
                <hr/>
                { this.state.serviceData ? <ServicesMap data={this.state.serviceData}/> : <Spin/>}


                <h1>Data Lists</h1>
                <hr/>
                {this.state.dataListsData ? 

                    <Table className='spin-before-load-dashboard-data' columns={this.state.data_lists_table_columns} dataSource={this.state.dataListsData} onChange={onChange} />
                    :
                    <Spin/>
            
                }

            
            </div>
        );
    }
}

